// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"styles_modalWrapper__2Gda1"};